/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PhraseData } from '../../../../utilities/localizedUtil';
import { ShareCardColorModel } from '../../../appAuthorized/dataTransformComponents/ColorShareCard';
import { Card, CardRowUI } from '../../../../bphComponents/bundle';
import COLORS from '../../../styles/Colors';

interface Props {
  children: React.ReactFragment;
  titleShowHidden: PhraseData;
  titleHideRevealed: PhraseData;
  shareCardColorModel: ShareCardColorModel;
}

interface State {
  showHidden: boolean;
}

export class ShareCardCategorySection extends React.Component<Props, State> {
  state = {
    showHidden: false,
  };

  render() {
    const { children, titleShowHidden, titleHideRevealed, shareCardColorModel } = this.props;
    const { showHidden } = this.state;

    if (!React.Children.count(children)) return null;

    const message = showHidden ? titleShowHidden : titleHideRevealed;

    return (
      <Card.CardSection
        style={{ backgroundColor: COLORS.gsLightest }}
      >
        <CardRowUI.TextAction
          hasBottomBorder={true}
          onClick={() => this.setState({ showHidden: !showHidden })}
        >
          <div className="font-small" style={{ color: shareCardColorModel.cssColor(1) }}>
            <FormattedMessage {...message} />
          </div>
        </CardRowUI.TextAction>

        {showHidden && children}
      </Card.CardSection>
    );
  }
}
